import { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';
import { LoadingView } from '../../../components/LoadingView/LoadingView';

export interface LoadingViewContext {
  toggleLoadingView: (state: Partial<LoadingViewContext>) => void;
  isLoading: boolean;
  loadingText: string;
}

export const LoadingViewContext = createContext<LoadingViewContext | undefined>(undefined);

export const useLoadingViewContext = (): LoadingViewContext => {
  const context = useContext(LoadingViewContext);
  if (context === undefined) {
    throw new Error('LoadingViewContext must be used within a LoadingViewContext.Provider');
  }
  return context;
};

export const LoadingViewContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [isLoading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('');
  const toggleLoadingView = (state: Partial<LoadingViewContext>) => {
    if (state.isLoading !== undefined) setLoading(state.isLoading);
    if (state.loadingText !== undefined) setLoadingText(state.loadingText);
  };

  return (
    <LoadingViewContext.Provider value={{ toggleLoadingView, isLoading, loadingText }}>
      <LoadingView />
      {children}
    </LoadingViewContext.Provider>
  );
};
